import React, { useMemo } from "react";
import CheckboxTreeView from "../../common/CheckboxTreeView";
import {
  buildEpsfAssignedScopeTree,
  buildEpsfCheckboxTreeData,
} from "./epsfExternalAppAccess";
import "./ExternalEpsfAccessTab.scss";

/**
 * Sponsor/CRO ePSF Access tab — Study → Site → three setup permissions.
 * Scope comes only from already-assigned Studies/Sites (Assigned Studies tab).
 */
export default function ExternalEpsfAccessTab({
  assignedRows = [],
  checkedIds = [],
  onCheckedIdsChange,
  readOnly = false,
  loading = false,
  onSave,
  saving = false,
}) {
  const scopeStudies = useMemo(
    () => buildEpsfAssignedScopeTree(assignedRows),
    [assignedRows],
  );
  const treeData = useMemo(
    () => buildEpsfCheckboxTreeData(scopeStudies),
    [scopeStudies],
  );

  const hasScope = scopeStudies.some((s) => (s.sites || []).length > 0);

  return (
    <div className="external-epsf-access-tab">
      <div className="external-epsf-access-tab__intro">
        <h3 className="external-epsf-access-tab__title">ePSF Access</h3>
        <p className="external-epsf-access-tab__help">
          Grant Sponsor IMP setup capabilities for Studies and Sites already
          assigned on Assigned Studies. Site pharmacy operations and Emergency
          Unblind are not configured here.
        </p>
      </div>

      {loading ? (
        <div className="external-epsf-access-tab__empty">Loading assigned scope…</div>
      ) : !hasScope ? (
        <div className="external-epsf-access-tab__empty">
          No assigned Study/Site scope yet. Assign Studies and Sites on the
          Assigned Studies tab first, then return here to grant ePSF setup
          permissions.
        </div>
      ) : (
        <div className="external-epsf-access-tab__tree-wrap">
          <CheckboxTreeView
            data={treeData}
            checkedIds={checkedIds}
            onChange={onCheckedIdsChange}
            checkboxType="all"
            cascadeFolders
            showIndeterminate
            defaultExpanded
            disabled={readOnly || saving}
          />
        </div>
      )}

      <div className="external-epsf-access-tab__actions">
        <button
          type="button"
          className="btn btn-primary"
          disabled={readOnly || saving || loading || !hasScope}
          onClick={() => onSave?.()}
        >
          {saving ? "Saving…" : "Save changes"}
        </button>
      </div>
    </div>
  );
}

export { buildEpsfAssignedScopeTree };
